export const dataHooks = {
  input: 'list-item-editable-input',
  approveButton: 'list-item-editable-approve-button',
  cancelButton: 'list-item-editable-cancel-button',
  approveButtonTooltip: 'list-item-editable-approve-button-tooltip',
  cancelButtonTooltip: 'list-item-editable-cancel-button-tooltip',
} as const;

export const ListItemEditableSize = {
  small: 'small',
  medium: 'medium',
} as const;

export enum ListItemEditableMargins {
  LIST_ITEM = 'list-item',
  NONE = 'none',
}
